<template>
  <div class="w-100">
    <div v-if="$is_mobile_view" class="ga-container fluid">
      <div class="d-flex align-items-start justify-content-center py-1">
        <template v-for="(step, stepIndex) in steps">
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 text-center">
              <div class="w-100 mb-1 lh-1">
                <span
                  v-if="step.order >= currentStep"
                  class="step-number body-3-3-2 font-lato mx-auto"
                  :class="{ active: step.order === currentStep }"
                  >{{ step.order }}</span
                >
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 23.9882C18.5648 23.9882 24 18.5439 24 11.9941C24 5.43262 18.553 0 11.9883 0C5.4353 0 0 5.43262 0 11.9941C0 18.5439 5.44707 23.9882 12 23.9882Z"
                    class="fill-primary" />
                  <path
                    d="M10.6824 17.7442C10.2824 17.7442 9.95296 17.5796 9.64709 17.1681L6.69413 13.5463C6.51767 13.3111 6.41178 13.0524 6.41178 12.782C6.41178 12.2528 6.82355 11.8177 7.35296 11.8177C7.69413 11.8177 7.95296 11.9235 8.24707 12.3116L10.6354 15.3924L15.6589 7.32581C15.8824 6.97304 16.1883 6.7849 16.4942 6.7849C17.0118 6.7849 17.4942 7.13767 17.4942 7.69033C17.4942 7.94904 17.3412 8.21949 17.2 8.46643L11.6706 17.1681C11.4235 17.5561 11.0824 17.7442 10.6824 17.7442Z"
                    fill="white" />
                </svg>
              </div>
              <p
                class="mb-0 body-3-1 w-100"
                :class="{ 'text-subcolor': step.order > currentStep }">
                {{ step.title }}
              </p>
            </div>
          </div>
          <template v-if="stepIndex + 1 < steps.length">
            <svg
              class="mx-4 flex-shrink-0 mt-2"
              height="12"
              viewBox="0 0 9 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.08521 7.17587C8.08521 6.96918 8.0026 6.77904 7.8455 6.63023L1.29793 0.214945C1.14913 0.0744042 0.96725 0 0.75231 0C0.330685 0 0 0.322417 0 0.75231C0 0.958989 0.0826715 1.14913 0.214945 1.28967L6.23341 7.17587L0.214945 13.062C0.0826715 13.2025 0 13.3845 0 13.5994C0 14.0293 0.330685 14.3517 0.75231 14.3517C0.96725 14.3517 1.14913 14.2773 1.29793 14.1285L7.8455 7.72148C8.0026 7.56444 8.08521 7.3825 8.08521 7.17587Z"
                fill="#222222" />
            </svg>
          </template>
        </template>
      </div>
    </div>
    <div v-else class="d-flex align-items-center justify-content-center w-100">
      <div
        class="d-flex align-items-center"
        :class="{ 'mr-4': stepIndex + 1 < steps.length }"
        v-for="(step, stepIndex) in steps">
        <span
          v-if="step.order >= currentStep"
          class="step-number body-3-3-2 font-lato mr-2"
          :class="{ active: step.order === currentStep }"
          >{{ step.order }}</span
        >
        <svg
          class="mr-2"
          v-else
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 23.9882C18.5648 23.9882 24 18.5439 24 11.9941C24 5.43262 18.553 0 11.9883 0C5.4353 0 0 5.43262 0 11.9941C0 18.5439 5.44707 23.9882 12 23.9882Z"
            class="fill-primary" />
          <path
            d="M10.6824 17.7442C10.2824 17.7442 9.95296 17.5796 9.64709 17.1681L6.69413 13.5463C6.51767 13.3111 6.41178 13.0524 6.41178 12.782C6.41178 12.2528 6.82355 11.8177 7.35296 11.8177C7.69413 11.8177 7.95296 11.9235 8.24707 12.3116L10.6354 15.3924L15.6589 7.32581C15.8824 6.97304 16.1883 6.7849 16.4942 6.7849C17.0118 6.7849 17.4942 7.13767 17.4942 7.69033C17.4942 7.94904 17.3412 8.21949 17.2 8.46643L11.6706 17.1681C11.4235 17.5561 11.0824 17.7442 10.6824 17.7442Z"
            fill="white" />
        </svg>

        <p
          class="mb-0 body-2-4"
          :class="{ 'text-subcolor': step.order > currentStep }">
          {{ step.title }}
        </p>

        <template v-if="stepIndex + 1 < steps.length">
          <svg
            class="ml-4"
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.08521 7.17587C8.08521 6.96918 8.0026 6.77904 7.8455 6.63023L1.29793 0.214945C1.14913 0.0744042 0.96725 0 0.75231 0C0.330685 0 0 0.322417 0 0.75231C0 0.958989 0.0826715 1.14913 0.214945 1.28967L6.23341 7.17587L0.214945 13.062C0.0826715 13.2025 0 13.3845 0 13.5994C0 14.0293 0.330685 14.3517 0.75231 14.3517C0.96725 14.3517 1.14913 14.2773 1.29793 14.1285L7.8455 7.72148C8.0026 7.56444 8.08521 7.3825 8.08521 7.17587Z"
              fill="#222222" />
          </svg>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      default: 1,
    },
  },
};
</script>
<style scoped>
.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #777 !important;
}
.step-number.active {
  border: 2px solid var(--merchant-primary-color);
  background-color: var(--merchant-primary-color);
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/HotelCheckoutStepper.vue